import { inject, injectable, injectWithTransform } from "tsyringe";
import { Logger, LoggerTransformer } from "@identity/utils";
import { IdentityEventSender } from "./identity-event-sender";
import { DataWarehouseEventType, IdentityEventParams } from "./types";
import { LoadTimeEventSender } from "./load-time-event-sender";
import { ChromeLabelSender } from "./chrome-label-sender";
import {
  ConsentsEventParams,
  ConsentsEventSender,
} from "./consents-event-sender";

@injectable()
export class DataWarehouseService {
  constructor(
    @injectWithTransform(Logger, LoggerTransformer, "DataWarehouseService")
    private logger: Logger,
    @inject(IdentityEventSender)
    private identityEventSender: IdentityEventSender,
    @inject(LoadTimeEventSender)
    private loadTimeEventSender: LoadTimeEventSender,
    @inject(ChromeLabelSender)
    private chromeLabelSender: ChromeLabelSender,
    @inject(ConsentsEventSender)
    private consentEventSender: ConsentsEventSender,
  ) {}

  track(eventType: DataWarehouseEventType, payload: unknown) {
    switch (eventType) {
      case DataWarehouseEventType.identity:
        this.identityEventSender.send(payload as IdentityEventParams);
        break;
      case DataWarehouseEventType.loadTime:
        this.loadTimeEventSender.send(payload as string);
        break;
      case DataWarehouseEventType.chromeLabel:
        this.chromeLabelSender.send(payload as string);
        break;
      case DataWarehouseEventType.consents:
        this.consentEventSender.send(payload as ConsentsEventParams);
        break;
      default:
        this.logger.info("Invalid event type to track");
    }
  }
}
